<template>
	<div class="document page-break">
		<p style="text-align: right;">
			Приложение № {{ index }}
			<br>к Договору № {{ $root.contract.number }} от {{ $root.contract.date }}
		</p>
		<h4 class="h">Спецификация № {{ index }}</h4>
		<div class="spcf_table">
			<table class="table table-bordered" cellpadding="6">
				<tbody>
					<tr>
						<th>№ п.п.</th>
						<th>Наименование</th>
						<th>Единица измерения</th>
						<th>Количество лицензий</th>
						<th>Цена, руб.</th>
						<td><b>Сумма(без НДС)</b><br></td>
					</tr>
					<tr>
						<td>1</td>
						<td>Информационно-аналитическая система «Seldon.Doc». Простая (неисключительная) лицензия сроком на {{  license_period }} месяцев.

						</td>
						<td>шт.</td>
						<td>{{ license_count }}</td>
						<td>{{ license_price }}</td>
						<td>{{ license_total_sum }}</td>
					</tr>
					<tr>
						<td></td>
						<th colspan="4">Итого:</th>
						<th>{{ license_total_sum }}</th>
					</tr>
				</tbody>
			</table>
		</div>
		<div>
			<p>
				<b>Основные функциональные возможности:</b>
				<br><b>Программа для ЭВМ Информационно-аналитическая система «Seldon.Doc»</b> - "Программа-клиент, предназначенная для автоматизации бизнес-процессов тендерных отделов. Программа позволяет:
				<ol>
					<li>В автоматическом (при условии совместного использования с Информационно-аналитической системой «Seldon 1.7») и ручном режиме загружать в программу полную и актуальную информацию об объявленных торгах с площадок, на которых размещены закупки;</li> 
				    <li>Систематизировать информацию об интересующих закупках и этапах участия в них;</li> 
				    <li>Оперативно распределять закупки по ответственным сотрудникам;</li>
				    <li>Вести документы внутри системы;</li>
				    <li>Контролировать и оценивать результаты работы сотрудников и подразделений;</li>
				    <li>Формировать аналитические отчёты по тендерной деятельности;</li>
				    <li>Осуществлять настройку, автоматическое формирование и направление уведомлений на электронную почту об изменениях в закупке, а также о действиях пользователей.</li>
				</ol>
				<b>Системные требования (рекомендуемые):</b>
				<br>Рабочее место пользователя Системы организовано посредством, как веб-интерфейса (работа с Системой в браузере), так и консоли (запуск Системы с помощью ярлыка на Рабочем столе). Для работы в веб-интерфейсе, рекомендованы следующие браузеры:	
				<br>- Internet Explorer версии 10 и выше;
				<br>- Chrome версии 37 и выше;
				<br>- Firefox версии 31 и выше;
				<br>- Opera версии 20 и выше;
				<br>- Safari (Mac) версии  7 и выше;
				<br>- Chromium(Linux) версии 37 и выше;
				<br>- Яндекс Браузер версии 14 и выше.

				<br><br>Обязательным условием работы в браузере, является наличие активного JavaScript.

				<br>Работа Системы возможна в следующих операционных системах:
				<br>- Windows XP SP 3 (32bit);
				<br>- Windows Vista (32bit/64bit);
				<br>- Windows 7 (32bit/64bit);
				<br>- Windows 8/8.1(32bit/64bit);
				<br>- Windows Server 2003;
				<br>- Windows Server 2008

				<br><br>Дополнительные требования:
				<br>- Установленнаяверсия Microsoft .NET Framework 3.5 SP1 для Windows XP;
				<br>- Установленнаяверсия Microsoft .NET Framework 4.0 для Windows 7;
				<br>- Установленная версия Microsoft .NET Framework 4.5 (или 4.5.1) для Windows 8/8.1;
				<br>- не менее 300 Мб свободного дискового пространства;
				<br>- 512 Мб оперативной памяти;

				<br><br><b>Способы и порядок использования:</b>Использование по прямому функциональному назначению на любых устройствах  в пределах количества учетных записей, которое указано в настоящей Спецификации. Функциональное использование осуществляется путем доступа через Сайт, размещенный по адресу http://doc.myseldon.com/ с помощью пароля (уникальная последовательность символов, генерируемая программно-аппаратными средствами, и предназначенная для обеспечения возможности использования Программы, а также идентификации пользователя с целью контроля правомерности использования).
				<br><br>Лицензиат обязуется передать Сублицензиату в течение 5 (пяти) рабочих дней с момента осуществления оплаты, посредством сетей передачи данных (на электронную почту, указанную в разделе 7 договора) средства идентификации (логин, пароль).
			</p>
		</div>
		<div>
			<table class="table table-bordered">
				<tbody>
					<tr>
						<th>
							<p>
								Лицензиат
								<br>{{ $root.licentiate.short_name }}
							</p>
						</th>
						<th>
							<p>
								Сублицензиат
								<br>{{ $root.sublicentiate.short_name }}
							</p>
						</th>
					</tr>
					<tr>
						<td>
							<p>{{ $root.licentiate.position }}</p>
							<br>_________________/{{ $root.licentiate.director_short }}/
								<br>М.П.
						</td>
						<td>
							<p>{{ $root.sublicentiate.position }}</p>
							<br>_________________/{{ $root.sublicentiate.director_short }}/
								<br>М.П.
						</td>
					</tr>
					<div class="sign_area">
						<div class="sign"></div>
					</div>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
	export default {
		props: [
			'index',
			'license_period', 
			'license_count', 
			'license_price', 
			'license_user_count', 
			'license_total_sum'
		],
	}
</script>